import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'contacts-navigation',
  templateUrl: './contacts-navigation.component.html',
  styleUrls: ['./contacts-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContactsNavigationComponent {
  @Output('onSelect') onSelect:EventEmitter<any> = new EventEmitter()

  public alphabetLetters: string[] =  [
    ...Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode('A'.charCodeAt(0) + i)),
    '#'
  ];

  public select(letter:string){
    let page = new PageEvent()
    let obj = {page: page, letter: letter}
    this.onSelect.emit(obj)
  }

}
